// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__XGhoG","tileContent":"Tile_tileContent__Y1frh","title":"Tile_title__cp0ho","description":"Tile_description__lwCeE"};